export default "__VITE_ASSET__2dceabaa__"